import { DateInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import SelectCnae from 'app/components/Select/SelectCnae';
import { PessoaJuridicaAutocomplete } from 'app/main/pessoa';
import React, { useEffect, useState } from 'react';

const ClienteDadosGeraisPessoaJuridica = ({
  id,
  name,
  values,
  errors = {},
  touched = {},
  onChange,
  onBlur,
  fetchPapel,
  possuiVinculo,
}) => {
  const { pessoaJuridica = {}, principalAtividadeEconomica = {}, optanteSimples = false, inscricaoMunicipal } = values;

  const alphaNumericRegex = /^[a-z0-9]+$/i;

  const _errors = errors?.pessoaJuridica || {};
  const _touched = touched?.pessoaJuridica || {};

  const [desabilitarCNPJ, setDesabilitarCNPJ] = useState(false);

  useEffect(() => {
    if (possuiVinculo && pessoaJuridica?.cnpj) {
      setDesabilitarCNPJ(true);
    }
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [possuiVinculo]);

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <PessoaJuridicaAutocomplete
          id={`${id}.cnpj`}
          name={`${name}.cnpj`}
          value={pessoaJuridica?.cnpj}
          error={_errors?.cnpj}
          touched={_touched}
          onBlur={onBlur}
          onChange={onChange}
          papel="cliente"
          fetchPapel={fetchPapel}
          disabled={desabilitarCNPJ}
        />
      </Grid>
      <Grid item xs={12} sm={10} md={10} lg={10} xl={10}>
        <TextInput
          id={`${id}.razaoSocial`}
          name={`${name}.razaoSocial`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaJuridica.razaoSocial}
          error={_errors.razaoSocial}
          touched={_touched.razaoSocial}
          fullWidth
          variant="outlined"
          label="Razão social"
          maxLength={150}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <DateInput
          fullWidth
          id={`${id}.dataFundacao`}
          name={`${name}.dataFundacao`}
          label="Data da fundação"
          value={pessoaJuridica.dataFundacao}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <SelectInput
          label="Indicador de inscrição estadual"
          id={`${id}.indicadorInscricaoEstadual`}
          name={`${name}.indicadorInscricaoEstadual`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaJuridica.indicadorInscricaoEstadual}
          options={[
            { id: 'CONTRIBUINTE', title: 'Contribuinte de ICMS' },
            { id: 'NAO_CONTRIBUINTE', title: 'Não contribuinte de ICMS ' },
            { id: 'CONTRIBUINTE_ISENTO', title: 'Contribuinte isento' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id={`${id}.inscricaoEstadual`}
          name={`${name}.inscricaoEstadual`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaJuridica.inscricaoEstadual}
          error={_errors.inscricaoEstadual}
          touched={_touched.inscricaoEstadual}
          fullWidth
          variant="outlined"
          replace={{ searchValue: /[^0-9]/gm, newValue: '' }}
          pattern={/^[0-9]*$/gm}
          optanteSimples
          maxLength={20}
          label="Inscrição estadual"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id={`pessoa.inscricaoMunicipal`}
          name={`pessoa.inscricaoMunicipal`}
          onChange={onChange}
          onBlur={onBlur}
          value={inscricaoMunicipal}
          error={errors.inscricaoMunicipal}
          touched={touched.inscricaoMunicipal}
          fullWidth
          variant="outlined"
          label="Inscrição municipal"
          maxLength={20}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id={`${id}.suframa`}
          name={`${name}.suframa`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaJuridica.suframa}
          error={_errors.suframa}
          touched={_touched.suframa}
          pattern={alphaNumericRegex}
          maxLength={9}
          fullWidth
          variant="outlined"
          label="SUFRAMA"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        {/* O cnae principal deveria ser associado a pessoa. mas devido a forma que o serviço pessoa foi modelado, está ligada a cliente */}
        <SelectCnae
          id="principalAtividadeEconomica"
          name="principalAtividadeEconomica"
          label="Principal atividade econômica"
          onChange={onChange}
          onBlur={onBlur}
          value={principalAtividadeEconomica}
          touched={_touched.principalAtividadeEconomica}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <FormControlLabel
          control={
            <Switch
              id={`optanteSimples`}
              name={`optanteSimples`}
              value={optanteSimples}
              checked={optanteSimples}
              onChange={onChange}
              onBlur={onBlur}
              color="primary"
            />
          }
          label="Optante pelo SIMPLES"
        />
      </Grid>
    </>
  );
};

export default ClienteDadosGeraisPessoaJuridica;
